const {
  produce
} = require("immer");

const initialState = {
  userUid: null,
  guestUid: null,
  groupUid: null,
  memberUid: null,
  platformUid: null,
  authenticated: false,
};

/**
 * Top level Reducer
 */

module.exports = function (state = initialState, action) {
  switch (action.type) {
    /**
     * INIT
     */
    case "USER_AUTHENTICATED":
      return produce(state, draft => {
        Object.assign(draft, action.payload.user)
        draft.authenticated = true
      })

    case "SOCKET_CONNECTION":
      return produce(state, draft => {
        Object.assign(draft, action.auth)
      });

    case "SOCKET_UNAUTHORIZED":
      return produce(state, draft => {
        draft = initialState;
      });

    default:
      return state;
  }
};
